import React from "react";
import { motion } from "framer-motion";
import { StarBurst } from "./StarBurst";
interface EnvelopeProps {
  label: string;
  sublabel: string;
  ariaLabel: string;
  open: boolean;
  onOpen: () => void;
  burstKey: string | number;
  children: React.ReactNode;
}
const ease = [0.23, 1, 0.32, 1] as const;
export function Envelope({
  label,
  sublabel,
  ariaLabel,
  open,
  onOpen,
  burstKey,
  children
}: EnvelopeProps) {
  return <div className="relative aspect-[3/2] w-full [perspective:1400px]" data-id="element-114" data-mp="2por20oaiw5eb">
      {/* Back */}
      <div className="absolute inset-0 rounded-lg bg-saffron-dark" data-id="element-115" data-mp="2lps43nn7l8wd" />

      {/* Letter */}
      <motion.div className="absolute inset-x-5 bottom-3 top-3 z-10 overflow-hidden rounded bg-white text-navy shadow-[0_2px_8px_rgba(0,0,0,0.18)]" initial={false} animate={{
      y: open ? "-74%" : "0%"
    }} transition={{
      duration: 0.3,
      ease,
      delay: open ? 0.22 : 0
    }} data-id="element-116" data-mp="2gob55xoabwif">
        <div className="flex h-1.5" aria-hidden="true" data-id="element-117" data-mp="10a2w95wftlp9">
          <span className="flex-1 bg-brgreen" data-id="element-118" data-mp="l2v2vefmp78b" />
          <span className="flex-1 bg-bryellow" data-id="element-119" data-mp="l467fggwej0h" />
          <span className="flex-1 bg-saffron" data-id="element-120" data-mp="p4gaoldb2vbn" />
          <span className="flex-1 bg-ingreen" data-id="element-121" data-mp="p35bkyut2bqv" />
        </div>
        <div className="px-6 py-4 sm:px-7 sm:py-5" data-id="element-122" data-mp="b4xf0s1olcg8">{children}</div>
      </motion.div>

      {/* Front pocket */}
      <div className="absolute inset-0 z-20 rounded-lg bg-saffron" style={{
      clipPath: "polygon(0 0, 50% 52%, 100% 0, 100% 100%, 0 100%)"
    }} data-id="element-123" data-mp="g2z0fjmkxnuv" />
      <div className="pointer-events-none absolute inset-x-0 bottom-5 z-20 text-center text-navy sm:bottom-7" data-id="element-124" data-mp="1d15mku59zwp">
        <p className="text-lg font-bold sm:text-xl" data-id="element-125" data-mp="3ojjyi5doawj7">{label}</p>
        <p className="text-xs font-medium text-navy/70 sm:text-sm" data-id="element-126" data-mp="3oleo3wzw3ctm">{sublabel}</p>
      </div>

      {/* Flap — green with a yellow edge, after Brazil's flag */}
      <motion.div className="absolute inset-x-0 top-0 h-full origin-top" initial={false} animate={{
      rotateX: open ? 180 : 0,
      zIndex: open ? 0 : 30
    }} transition={{
      rotateX: {
        duration: 0.3,
        ease
      },
      zIndex: {
        duration: 0,
        delay: open ? 0.15 : 0.3
      }
    }} data-id="element-127" data-mp="3el4aib9y03dx">
        <div className="absolute inset-0 rounded-t-lg bg-bryellow" style={{
        clipPath: "polygon(0 0, 100% 0, 50% 56%)"
      }} data-id="element-128" data-mp="2vodl82te6ktx" />
        <div className="absolute inset-0 bg-brgreen" style={{
        clipPath: "polygon(4% 0, 96% 0, 50% 51%)"
      }} data-id="element-129" data-mp="2lqzbsn5vywb4" />
        {/* Seal — Ashoka chakra in navy on Brazilian yellow */}
        <motion.svg viewBox="-12 -12 24 24" className="absolute left-1/2 top-[56%] h-14 w-14 -translate-x-1/2 -translate-y-1/2 drop-shadow sm:h-16 sm:w-16" animate={{
        opacity: open ? 0 : 1
      }} transition={{
        duration: 0.12
      }} aria-hidden="true" data-id="element-130" data-mp="3jcnaxftq7sqc">
          <circle r={11.5} fill="#f7c813" data-id="element-131" data-mp="34jjvpf3lxr2s" />
          <circle r={8} fill="none" stroke="#0b1f4d" strokeWidth={0.9} data-id="element-132" data-mp="1y1n822tbvgg7" />
          <circle r={1.3} fill="#0b1f4d" data-id="element-133" data-mp="1t2abgqcnmv0f" />
          {Array.from({
          length: 24
        }, (_, i) => <line key={i} y1={-1.3} y2={-8} stroke="#0b1f4d" strokeWidth={0.35} transform={`rotate(${i * 15})`} data-id="element-134" data-mp="8k9kmrzofo7l" />)}
        </motion.svg>
      </motion.div>

      {open && <StarBurst key={burstKey} data-id="element-135" data-mp="djm89eydgzb8" />}

      {!open && <button type="button" onClick={onOpen} aria-label={ariaLabel} className="absolute inset-0 z-50 rounded-lg transition-transform duration-150 ease-out hover:-translate-y-1 active:scale-[0.98] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-bryellow focus-visible:ring-offset-4 focus-visible:ring-offset-navy" data-id="element-136" data-mp="ii5qp5drbsyu" />}
    </div>;
}